module.exports = __webpack_public_path__ + "post-listing-block-6-image-step3@2x-B62RnPr.png";